export default "__VITE_ASSET__Csb570tr__"